import { z } from "zod";
import { components } from "@opstel/gen/api/v2";

export interface ComponentVersion {
  componentName: string;
  version: string;
}

export interface AboutInfo {
  versions: ComponentVersion[];
}

export const versionInfoSchema = z.object({
  componentName: z.string(),
  version: z.string(),
}) satisfies z.ZodType<ComponentVersion, components["schemas"]["ComponentVersion"]>;

export const aboutInfoSchema = z.object({
  versions: z.array(versionInfoSchema),
}) satisfies z.ZodType<AboutInfo, components["schemas"]["AboutInfo"]>;
